export default (Vue) => {

    // 01.权限检查指令
    Vue.directive('has', {
        bind: function (el, binding) {
            if (!Vue.prototype.$_has(binding.expression)) {
                setTimeout(() => el.parentNode.removeChild(el))
            }
        }
    })

    // 02.权限检查方法
    Vue.prototype.$Permissions = function (value) {
        return Vue.prototype.$_has(value)
    }

    // 03.权限检查
    Vue.prototype.$_has = function (value) {

        // 01.定义反馈结果
        let Result = false
        // 02.获取权限数组
        let Permissions = localStorage.getItem('userPermissions')
        if (Permissions === undefined || Permissions == null) {
            Result = false
        } else {
            for (let l = 0; l < value.length; l++) {
                if (Permissions.indexOf(value[l]) > 0) {
                    Result = true
                }
            }

        }
        return Result
    }

}
